// src/lib/queryClient.ts
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 3,      // 3 min — data is considered fresh for 3 minutes
      gcTime: 1000 * 60 * 30,        // 30 min — keep unused cache long enough to survive
                                      // footer navigation sessions. Previously 10 min,
                                      // which caused cache loss when users browsed other
                                      // pages for more than 10 min before returning.
      retry: 1,                       // retry once on failure
      refetchOnWindowFocus: false,    // don't refetch when admin switches tabs
      refetchOnReconnect: true,       // do refetch when network comes back
    },
    mutations: {
      retry: 0,                       // never retry mutations (create/update/delete)
    },
  },
});